import React, {useEffect, useState} from 'react';
// @ts-ignore
import Select, {components} from 'react-select'
import styled from 'styled-components'

const customStyles = {
    control: () => ({
        width: '260px',
        minHeight: '50px',
        display: 'flex',
        position: 'relative',
        border: '3px solid rgba(188, 224, 253, 1)',
        borderRadius: '10px',
        color: 'rgba(0,0,0,1)',
        paddingLeft: '9px'
    }),
    placeholder: () => ({
        color: 'black',
        fontSize: '16px',
        fontWeight: 'bold'
    }),
    indicatorSeparator: () => ({
        width: 0
    }),
    menu: () => ({
        width: '260px',
        background: 'white',
        border: '3px solid rgba(188, 224, 253, 1)',
        borderRadius: '10px',
        marginTop: '5px',
        position: 'absolute',
        fontWeight: 'normal',
        zIndex: 111,
        maxHeight: '300px',

    }),
    multiValue: () => ({
        background: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        paddingTop: '0px',
        borderRadius: '10px'
    }),
    multiValueRemove: () => ({
        borderRadius: '200px',
        marginLeft: '7px',
        marginRight: '5px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    }),
    menuList: () => ({
        padding: 0,
        background: 'white',
        borderRadius: '10px',
        maxHeight: '200px',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            background: 'white',
            width: '3px',
            borderRadius: '10px',

        },
        '&::-webkit-scrollbar-thumb': {
            background: 'rgba(188, 224, 253, 1)',
            borderRadius: '10px'
        }
    }),
    option: () => ({
        '&:first-child': {
            borderTop: '0'
        },
        fontWeight: 'normal',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        paddingLeft: '20px',
        '&:hover': {
            background: 'rgba(244, 247, 254, 1)'
        },
        borderTop: '1px solid rgba(39, 139, 154, 0.2)'

    })
}
const mobileStyles = {
    control: () => ({
        width: '260px',
        minHeight: '35px',
        display: 'flex',
        position: 'relative',
        border: '3px solid rgba(188, 224, 253, 1)',
        borderRadius: '10px',
        color: 'rgba(0,0,0,1)',
        paddingLeft: '9px',
        fontSize: '15px'
    }),
    placeholder: () => ({
        color: 'black',
        fontSize: '16px',
        fontWeight: 'bold'
    }),
    indicatorSeparator: () => ({
        width: 0
    }),
    menu: () => ({
        width: '260px',
        background: 'white',
        border: '3px solid rgba(188, 224, 253, 1)',
        borderRadius: '10px',
        marginTop: '5px',
        position: 'absolute',
        fontWeight: 'normal',
        zIndex: 111

    }),
    multiValue: () => ({
        background: 'white',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    }),
    multiValueRemove: () => ({
        borderRadius: '200px',
        marginLeft: '7px',
        marginRight: '5px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer'
    }),
    menuList: () => ({
        padding: 0,
        background: 'white',
        borderRadius: '10px',
        maxHeight: '200px',
        overflow: 'auto',
        '&::-webkit-scrollbar': {
            background: 'white',
            width: '3px',
            borderRadius: '10px',

        },
        '&::-webkit-scrollbar-thumb': {
            background: 'rgba(188, 224, 253, 1)',
            borderRadius: '10px'
        }
    }),
    option: () => ({
        '&:first-child': {
            borderTop: '0'
        },
        fontWeight: 'normal',
        height: '50px',
        display: 'flex',
        alignItems: 'center',
        cursor: 'pointer',
        paddingLeft: '20px',
        '&:hover': {
            background: 'rgba(244, 247, 254, 1)'
        },
        borderTop: '1px solid rgba(39, 139, 154, 0.2)'

    })
}

type option = {
    label: string,
    value: string
}

type types = {
    downIcon?: any
    options?: Array<option>,
    onChange?: any,
    placeholder?: string,
    value: any

}

function MultiSelect(props: types) {

    const [mobile, setMobile] = useState(false)


    useEffect(() => {
        setMobile(window.innerWidth <= 1100)

        window.addEventListener('resize', _ => {
            setMobile(window.innerWidth <= 1100)
        })
        return () => {
            window.removeEventListener('resize', _ => {
                setMobile(window.innerWidth <= 1100)
            })
        }
    }, [])
    const IndicatorsContainer = (props: any) => {
        return <components.IndicatorsContainer {...props}>
            <div style={{
                height: '100%',
                display: 'flex',
                alignItems: 'center',
                paddingRight: '9px'
            }}>
                {props.children}
            </div>
        </components.IndicatorsContainer>
    }
    const MultiValueContainer = (props: any) => {
        return <components.MultiValueContainer {...props}>
            <MultiOption>            {props.children}
            </MultiOption>
        </components.MultiValueContainer>
    }
    const MultiValue = (props: any) => {
        return <components.MultiValue {...props}>
            <Multi>{props.children}</Multi>
        </components.MultiValue>
    }
    const MultiValueLabel = (props: any) => {
        return <components.MultiValueLabel {...props}>
            <Label>{props.children}</Label>
        </components.MultiValueLabel>
    }
    const Option = (props: any) => (
        <components.Option {...props}>
            <StyledOption title={props?.data?.label}>  {props.children}</StyledOption>
        </components.Option>
    )
    const NoOptionsMessage = (props: any) => {
        return <components.NoOptionsMessage {...props}>
            <div>Нет данных</div>
        </components.NoOptionsMessage>
    }
    const DropdownIndicator = (propss: any) => {
        return (
            <components.DropdownIndicator {...propss}>
                <StyledDropdownIndicator>
                    {props.downIcon || '▼'}
                </StyledDropdownIndicator>
            </components.DropdownIndicator>
        )
    }

    return (
        <div>

            <Select isMulti
                    options={props.options}
                    onChange={(options: Array<option>) => props.onChange(options || [])}
                    value={props?.value}
                    components={{
                        IndicatorsContainer,
                        Option,
                        NoOptionsMessage,
                        DropdownIndicator,
                        MultiValueContainer,
                        MultiValue,
                        MultiValueLabel
                    }}
                    styles={mobile ? mobileStyles : customStyles}
                    closeMenuOnSelect={false}
                    placeholder={props.placeholder || 'Специализация'}
                    isClearable={false}
                    isSearchable={false}
                    maxMenuHeight={200}
            />


        </div>
    );
}

export default MultiSelect;

const Multi = styled.div`
  border-radius: 10px;
  display: flex;
  padding: 0;
`
const Label = styled.div`
  font-size: 14px;


`
const MultiOption = styled.div`
  border: 3px solid rgba(188, 224, 253, 1);
  border-radius: 10px;
  display: flex;
  font-size: 16px;
  margin: 2px;
  align-items: center;

  &::-webkit-scrollbar-thumb {

  }
`
const StyledDropdownIndicator = styled.div`
  cursor: pointer;
  width: 15px;
  height: 15px;
`
const StyledOption = styled.div`
  font-weight: normal;
`